// src/components/HStack.tsx

import { Stack, SxProps, Theme } from '@mui/material'
import { ReactNode } from 'react'

type Props = {
  alignItems?:
    | 'flex-start'
    | 'flex-end'
    | 'center'
    | 'stretch'
    | 'baseline'
    | 'top'
  children: ReactNode
  direction?: 'row' | 'row-reverse' | 'column' | 'column-reverse'
  justifyContent?:
    | 'flex-start'
    | 'flex-end'
    | 'center'
    | 'space-between'
    | 'space-around'
    | 'space-evenly'
  spacing?: number
  className?: string
  sx?: SxProps<Theme>
  gap?: number
  onClick?: (_: any) => void
}

export const HStack = ({
  alignItems = 'center',
  children,
  direction = 'row',
  justifyContent = 'flex-start',
  spacing = 1,
  className,
  gap,
  sx,
}: Props) => (
  <Stack
    alignItems={alignItems}
    direction={direction}
    justifyContent={justifyContent}
    spacing={spacing}
    className={className}
    gap={gap}
    sx={{ ...sx }}
  >
    {children}
  </Stack>
)
